import { render, staticRenderFns } from "./FacilityDuplicateModal.vue?vue&type=template&id=6ec51936&scoped=true&"
import script from "./FacilityDuplicateModal.vue?vue&type=script&lang=js&"
export * from "./FacilityDuplicateModal.vue?vue&type=script&lang=js&"
import style0 from "./FacilityDuplicateModal.vue?vue&type=style&index=0&id=6ec51936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec51936",
  null
  
)

export default component.exports